import AsyncAccessView from './AsyncAccessView';

export default AsyncAccessView;
